import React from "react" ;
import "../../styles/UI/ribbon.scss";

const Ribbon = (props) => {
    return (
        <div
            className={props.leaf ? "ribbon-wrap ribbon-wrap_leaf" : "ribbon-wrap"} 
        >
            <div className="ribbon">
                <div className="ribbon-content">
                    {props.text}
                </div>
            </div>
        </div>
    );
}

export default Ribbon;
